<template>
    <Toast position="top-center">
        <template #message="slotProps">
            <ToastTemplate :message="slotProps.message" />
        </template>
    </Toast>
    <router-view></router-view>
    <Modal />
    <MissingTranslationsWidget />
    <CookieConsentModal />
</template>

<script>
import ToastTemplate from './components/ToastTemplate.vue'
import Modal from './components/Modal.vue'
import MissingTranslationsWidget from './components/MissingTranslationsWidget.vue'
import CookieConsentModal from './components/CookieConsentModal.vue'

export default {
    name: 'App',

    components: {
        ToastTemplate,
        Modal,
        MissingTranslationsWidget,
        CookieConsentModal,
    },
}
</script>
